export default __webpack_public_path__ + "static/media/usability.d0fd90db.svg";